<template>
    <div v-if="isOpen" class="search-window">
        <!-- PRODUCTS -->
        <div class="search-window__products">
            <ProductAgent
                v-for="(product, idx) in products"
                :key="idx"
                :product="product"
                :layoutType="'plank-showcase'"
                :isInTightList="products.length === (idx + 1) ? false : true"
            />
            <div v-if="products.length === 0" class="search-window__products__empty">
                <span>{{ $t('searchWindowScreenEmptyDescription') }}</span>
            </div>
        </div>

        <!-- BLUR -->
        <transition name="fade">
            <div v-if="isLoading" class="search-window__blur"></div>
        </transition>
        
        <!-- CATEGORIES -->
        <div class="search-window__categories">
            <h3 :class="{ 'disabled': isCategoriesEmpty }">{{ $t('headerSearchWindowTextAttributeCategories') }}</h3>
            <div class="search-window__categories__links">
                <NuxtLink 
                    v-for="(link, idx) in categories" 
                    :key="idx" 
                    :to="localePath(link.route)"
                >{{ link.name }}</NuxtLink>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes, { nullable } from "vue-types";
import { ProductAgent } from '@/themes/novaporta/components/reusable/ProductAgent/types'
import { CategoryLink } from '~/themes/novaporta/types/categories'

export default {
    name: 'SearchWindow',
    props: {
        isOpen: VueTypes.bool.isRequired,
        isLoading: VueTypes.bool.def(false),
        products: VueTypes.arrayOf(VueTypes.oneOfType([ProductAgent, nullable])).def([]),
        categories: VueTypes.arrayOf(CategoryLink).def([])
    },
    computed: {
        isCategoriesEmpty() {
            return this.categories.length ? false : true
        },
    },
    components: {
        ProductAgent: () => import('@/themes/novaporta/components/reusable/ProductAgent'),
    },
}
</script>

<style lang="scss">
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>